export function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// export const AI_SERVER_PATH = "http://10.240.1.157:52025";
// export const AI_SERVER_PATH = "http://192.168.1.46:52024";
export const AI_SERVER_PATH = "http://i-seika.com/ai";
